<template>
    <v-col cols="12" class="PaymentSuccess mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >

            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                <v-row >
                        <v-col>
                            <h2 class="font-weight-medium text-center title-reports my-6">Detalle de tu compra</h2>
                        </v-col>
                         
                    </v-row>

                    <v-row>
                         <v-col cols="12" class="d-none d-md-block">
                                <v-stepper alt-labels>
                                    <v-stepper-header class="text-center elevation-0">
                                        <v-stepper-step step="1" complete>Selecciona tus productos</v-stepper-step>

                                        <v-divider class="complete"></v-divider>

                                        <v-stepper-step step="2" complete>Selecciona tu medio de pago</v-stepper-step>

                                        <v-divider class="complete"></v-divider>

                                        <v-stepper-step step="3" complete>Datos de facturación</v-stepper-step>

                                        <v-divider class="complete"></v-divider>

                                        <v-stepper-step step="4" complete>Términos y condiciones</v-stepper-step>

                                        <v-divider class="complete"></v-divider>

                                        <v-stepper-step step="5" complete>Realiza tu pago</v-stepper-step>
                                        <v-divider class="complete"></v-divider>

                                        <v-stepper-step step="6" complete>Comprobante de compra</v-stepper-step>
                                    </v-stepper-header>
                                </v-stepper>
                            </v-col>
                        <v-col cols="12" lg="1">
                            <img
                                src="@/assets/images/reports/ico/check-big.png"
                                alt="check bog">
                        </v-col>
                        <v-col cols="12" lg="11">
                            <h2 class="font-weight-medium">Tu pago fue aprobado! ya puedes descargar tu informe </h2>
                            <p class="text-payment">Hola <b>Usuario!</b> Ya puedes comenzar a utilizar las caracteristicas de NEOCITY.<br>
                                    Hemos enviado un correo a marcos@neocity.cl con el comprobante.</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="5">
                                <h4 class="subtitle-payment">Detalle de tu compra</h4>
                                <v-card
                                    class="mx-auto my-3 shadow-1 rounded-lg seleccionServicios"
                            >
                                <v-list-item three-line>
                                    <v-list-item-avatar
                                            tile
                                            size="120"
                                            color=""
                                            class=""
                                    >
                                        <v-col>
                                            <img
                                            src="@/assets/images/reports/ico/report.png"
                                            alt="report 10">
                                        </v-col>
                                    </v-list-item-avatar>
                                        <v-col cols="8">
                                            <h4 class="mb-1">Plan 10 informes  - Análisis de desempeño</h4>
                                            <p>Lorem Ipsum is simply dummy text of the printing<br>
                                                and typesetting industry. Lorem Ipsum has been<br>
                                                the industry's standard </p>
                                        </v-col>
                                    </v-list-item>
                                </v-card>
                                <v-card
                                        class="mx-auto my-3 shadow-1 rounded-lg seleccionServicios"
                                >
                                    <v-list-item three-line>
                                        <v-list-item-avatar
                                                tile
                                                size="120"
                                                color=""
                                                class=""
                                        >
                                            <v-col>
                                                <img
                                                src="@/assets/images/reports/ico/report-5.png"
                                                alt="report 10">
                                            </v-col>
                                        </v-list-item-avatar>
                                        <v-col cols="8">
                                                <h4 class="mb-1">Plan 5 informes  - Consumo Anual Energía</h4>
                                                <p>Lorem Ipsum is simply dummy text of the printing<br>
                                                and typesetting industry. Lorem Ipsum has been<br>
                                                the industry's standard </p>
                                        </v-col>
                                    </v-list-item>
                                </v-card>
                        </v-col>
                        <v-col cols="12" lg="3">
                            <h4 class="subtitle-payment">Información de pago</h4>
                            <v-card class="elevation-0 mt-4 pa-4">
                                    <v-col cols="12" class="pb-3">Botón de pago bancarios</v-col>
                                    <v-col cols="12" class="py-1"> <strong> Webpay Plus webServices </strong> </v-col>
                                    <v-col cols="12" class="py-1">Tipo de transacción: venta</v-col>
                                    <v-col cols="12" class="py-1">Resultado: transacción aprobada</v-col>
                                    <v-col cols="12" class="py-1">Nº Orden webpay: 132424-2424</v-col>
                                    <v-col cols="12" class="py-1">Fecha: 2020-08-11 16:12</v-col>
                                    <v-col cols="12" class="py-1">Últimos 4 nums de tarjeta: xxxx3153</v-col>
                                    <v-col cols="12" class="py-1">Código autorización: 001313</v-col>
                                    <v-col cols="12" class="py-1">Tipo de pago: debito</v-col>
                                    <v-col cols="12" class="py-1">Tipo de cuotas: venta debito</v-col>
                                    <v-col cols="12" class="py-1">Número cuotas: 0</v-col>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg='5'>
                            <v-row>
                                <v-col>
                                    <v-btn color="primary"
                                        raised
                                        outlined
                                        to="/system/consumer/dashboard"
                                        class="pa-6 px-12" style="width:100%">Ir a consumidor</v-btn>
                                </v-col>
                                 <v-col>
                                    <v-btn color="primary"
                                        raised
                                        outlined
                                        to="/system/generator/dashboard"
                                        class="pa-6 px-12" style="width:100%">Ir a Generador</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    export default {
        name: 'PaymentSucces',
        created: function () {
            //this.$emit('SetcolorMenu', '#7F03BB');
            }
    }
</script>